import imageHasExtension from './imageHasExtension';

const DEFAULT_EXTENSION = '.jpg';

function getImageWithExtension(src, ext) {
  if (!src) return null;
  if (imageHasExtension(src)) return src;
  return `${src}${ext || DEFAULT_EXTENSION}`;
}

export default getImageWithExtension;
